export default __webpack_public_path__ + "static/media/win.b482700e.mp3";